import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import axiosInstance from "../Utils/axiosInstance";
import { getCallerUrl, getCookieValue, updateStorage } from "../Utils/utils";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const submitStandaloneGooglePayPayment = createAsyncThunk(
  "standaloneGooglePay/submitPayment",
  async ({ token, payload }, { rejectWithValue }) => {
    if (!token) {
      return rejectWithValue({ message: "Missing checkout session token" });
    }
    try {
      const headers = {
        "X-Request-Id": uuidv4(),
        "X-Caller-Url": getCallerUrl(),
      };
      const shopperSessionToken = getCookieValue("shopper_token") || localStorage.getItem("sessionToken");
      if (shopperSessionToken) {
        headers.Authorization = `Session ${shopperSessionToken}`;
      }

      const response = await axiosInstance.post(
        `${baseUrl}/checkout/sessions/${token}`,
        payload,
        { headers }
      );

      updateStorage("session", "update", "t_id", response?.data?.transactionId);

      if (
        response.data?.status?.status === "Rejected" ||
        response.data?.status?.status === "Failed"
      ) {
        return rejectWithValue(response?.data);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

const initialState = {
  submitLoading: false,
  submitError: null,
  submitData: null,
};

const standaloneGooglePaySlice = createSlice({
  name: "standaloneGooglePay",
  initialState,
  reducers: {
    resetStandaloneGooglePay(state) {
      state.submitLoading = false;
      state.submitError = null;
      state.submitData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitStandaloneGooglePayPayment.pending, (state) => {
        state.submitLoading = true;
        state.submitError = null;
      })
      .addCase(submitStandaloneGooglePayPayment.fulfilled, (state, action) => {
        state.submitLoading = false;
        state.submitData = action.payload;
      })
      .addCase(submitStandaloneGooglePayPayment.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitError = action.payload;
        state.submitData = null;
      });
  },
});

export const { resetStandaloneGooglePay } = standaloneGooglePaySlice.actions;
export default standaloneGooglePaySlice.reducer;
